export const userConstatnt = {
    USERDATA: 'USERDATA',
    MENUID: 'MENUID',
}